<template>
  <identity-provider-form
    :errors="errors"
    :model="identity_provider"
    title="New Identity Provider"
    action="createIdentityProvider"
    @createIdentityProvider="createIdentityProvider"
  />
</template>

<script>
import IdentityProviderForm from './Form';
import { closeModal, showToast } from '@inscribe/signal';
import { formatXhrErrorMessage } from '@/utils/xhrErrors';

export default {
  components: {
    'identity-provider-form': IdentityProviderForm,
  },
  data() {
    return {
      identity_provider: {
        sign_metadata: true,
        authn_requests_signed: true,
        want_messages_signed: true,
      },
      errors: [],
    };
  },
  mounted() {
    this.$store.commit('setSelectedIdentityProviderId', undefined);
  },
  methods: {
    createIdentityProvider(identityProviderData) {
      this.errors = []; // Clear previous errors
      this.$store
        .dispatch('createIdentityProvider', { ...identityProviderData })
        .then(
          (response) => {
            this.$store.commit('setIdentityProvider', response.data.data);
            showToast({
              text: 'Identity Provider successfully created.',
            });
            this.$store.dispatch('getIdentityProvider');
            this.$router.push({ name: 'saml-settings-view' });
            closeModal('saml-modal');
          },
          (error) => {
            const errorMessage = formatXhrErrorMessage({
              errorPrefix: 'Error creating identity provider',
              error,
            });
            this.errors = [{ message: errorMessage }];
          },
        );
    },
  },
};
</script>
